import { Box, Button, Typography } from '@mui/material';
import Image from '../../../assets/images/play-button.png';
import { useNavigate } from 'react-router-dom';
import K2Bg from '../../../assets/images/k2-background.png';
import { useState } from 'react';

const OnBoardingIntroduction = () => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);

  const navigateToRegister = () => {
    navigate('/onboarding');
  };

  return (
    <Box sx={{ height: '100vh', width: '100%', overflowY: 'scroll' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '100%',
          aspectRatio: '472/229',
          backgroundImage: `url(${K2Bg})`,
          backgroundSize: 'cover',
          borderRadius: '0 0 24px 24px',
          overflow: 'hidden',
        }}
      >
        {showVideo ? (
          <video
            width='100%'
            height='100%'
            controls
            autoPlay
            style={{ objectFit: 'cover' }}
          >
            <source
              src='https://qa-assets.k2businessgroup.com/K2_Client_Dashboard_Introduction.mp4'
              type='video/mp4'
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <>
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: '32px',
                fontWeight: 600,
                fontFamily: 'Open Sans',
                color: '#FAFAFB',
                lineHeight: '40px',
              }}
            >
              <span>Explore how K2 simplifies your tax management</span>
              <span>while propelling you towards your financial goals</span>
            </Typography>
            <img
              src={Image}
              style={{ cursor: 'pointer' }}
              onClick={() => setShowVideo(true)}
            />
          </>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '40vh',
          padding: '0 64px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'end',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <Typography
              sx={{
                fontSize: '48px',
                fontWeight: 700,
                color: '#52AB98',
                lineHeight: '44px',
              }}
            >
              Revolutionize Your Tax Strategy with K2
            </Typography>
            <Typography
              sx={{ fontSize: '20px', fontWeight: 400, color: '#202A2D' }}
            >
              Ready to embark on a seamless tax journey? Hit 'Next' to get
              started.
            </Typography>
          </Box>
          <Button
            variant='contained'
            sx={{ padding: '12px 90px' }}
            onClick={navigateToRegister}
          >
            Next
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default OnBoardingIntroduction;
